module.exports = __webpack_public_path__ + "static/img/protection-01.f7f9914.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/protection-01.png
// module id = 135
// module chunks = 0